import { render, staticRenderFns } from "./OrderFabricExtraProcessTypeTable.vue?vue&type=template&id=af25790a&scoped=true&"
import script from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af25790a",
  null
  
)

export default component.exports